/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PlatformFeeWithdrawalPaginatedProperty =
  typeof PlatformFeeWithdrawalPaginatedProperty[keyof typeof PlatformFeeWithdrawalPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformFeeWithdrawalPaginatedProperty = {
  NAME: 'NAME',
  PLATFORM_FEE_BALANCE: 'PLATFORM_FEE_BALANCE',
  BONDSMITH_FEE_BALANCE: 'BONDSMITH_FEE_BALANCE',
} as const;
